module.exports = __webpack_public_path__ + "static/media/screenshot@1x.a2ffde92.png";